import { createContext } from "react";

const tripContext = createContext();

export default tripContext;
